<div class="content-block light-control-host">
  <div>
    <h1>Add Ons</h1>
    <div>
      Add ons extend {{ uiService.productName }}'s replications capabilities to resources beyond your AWS environments.
      You define integrations with these 3rd party services here and then associate them with your applications where
      you need them.
    </div>
  </div>

  <h3 class="margin-top">Configured add ons</h3>
  <ng-container *ngIf="licensedForIntegrations; else unlicensed">
    <ng-container *ngLet="integrations as definedIntegrations">
      <table class="arpio-table">
        <tr>
          <th class="strong-text integration-column">Add on type</th>
          <th class="strong-text name-column">Description</th>
          <th class="strong-text action-column">Actions</th>
        </tr>
        <tr *ngIf="definedIntegrations.length === 0">
          <td colspan="3">No add ons have been configured.</td>
        </tr>
        <tr
          account-integration
          *ngFor="let integration of definedIntegrations"
          [integration]="integration"
          (delete)="deleteIntegration(integration)"
          (edit)="editIntegration(integration)"
        ></tr>
      </table>
    </ng-container>
    <div class="flex-center-row control-header">
      <div class="spacer"></div>
      <button class="arpio-button" (click)="configureNewIntegration()">CONFIGURE NEW ADD ON</button>
    </div>
  </ng-container>
  <ng-template #unlicensed> Your {{ uiService.productName }} account is not licensed for any add ons. </ng-template>
</div>

<modal-dialog #editIntegrationDialog [dialogTemplate]="editIntegrationDialogTemplate"></modal-dialog>

<ng-template #editIntegrationDialogTemplate>
  <div class="flex-center-column">
    <div class="dialog light-content-panel double-margin-top">
      <edit-integration-dialog
        [integration]="integrationToEdit"
        [saving]="savingIntegration"
        (cancel)="dismissEditModal()"
        (save)="commitIntegration($event)"
      >
      </edit-integration-dialog>
    </div>
  </div>
</ng-template>
